export function formatLabelWithEmoji(emoji, name) {
  if (!name) return null;

  const rawEmoji = emoji == null || emoji === 'null' ? '' : String(emoji).trim();
  return rawEmoji ? `${rawEmoji} ${name}` : name;
}
